<template>
  <div class="rightModal">
    <b-form-group
      v-if="form.type.name != 'SRV'"
      :state="validateState('type')"
      class="mb-3"
    >
      <SwitchButton
        v-model="form.subdomain"
        @input="switchChange"
        class="border-0 px-0"
        >{{ $t('global.subdomain') }}</SwitchButton
      >
    </b-form-group>

    <Input
      label="servers.recordSubdomain"
      id="name"
      :class="[{ 'mb-1': form.name }]"
      :placeholder="
        !form.subdomain ? detailData.name : 'servers.recordSubdomain'
      "
      v-model="form.name"
      :disabled="!form.subdomain"
      v-if="refreshName && form.type.name != 'SRV'"
      :state="null"
    >
      <i v-if="!form.subdomain" class="fas fa-lock-alt"></i>
    </Input>

    <b-form-group v-if="form.name">
      <span class="text-muted d-block text-right font-size-sm font-weight-bold"
        >{{ form.name }}.{{ detailData.name }}</span
      >
    </b-form-group>

    <b-form-group
      :label="$t('servers.recordType')"
      :state="validateState('type')"
    >
      <multiselect
        v-model="form.type"
        :options="typeList"
        track-by="id"
        label="name"
        :allowEmpty="false"
        :show-labels="false"
        :searchable="true"
        @select="selectedRecordType"
        :placeholder="$t('servers.recordType')"
        :show-no-results="false"
      />
    </b-form-group>

    <Input
      v-if="form.type.name != 'SRV'"
      label="servers.contentValue"
      placeholder="servers.contentValue"
      id="content"
      v-model="form.content"
    />

    <Input
      v-if="
        refreshSRVFields && (form.type.name == 'MX' || form.type.name == 'SRV')
      "
      label="global.priority"
      placeholder="global.priority"
      id="priority"
      v-model="form.priority"
    />

    <Input
      v-if="refreshSRVFields && form.type.name == 'SRV'"
      label="global.service"
      placeholder="global.service"
      id="service"
      v-model="form.service"
    />

    <Input
      v-if="refreshSRVFields && form.type.name == 'SRV'"
      label="global.protocol"
      placeholder="global.protocol"
      id="protocol"
      v-model="form.protocol"
    />

    <Input
      v-if="refreshSRVFields && form.type.name == 'SRV'"
      label="global.weight"
      placeholder="global.weight"
      id="weight"
      v-model="form.weight"
    />

    <Input
      v-if="refreshSRVFields && form.type.name == 'SRV'"
      label="global.port"
      placeholder="global.port"
      id="port"
      v-model="form.port"
    />

    <Input
      v-if="refreshSRVFields && form.type.name == 'SRV'"
      label="global.target"
      placeholder="global.target"
      id="target"
      v-model="form.target"
    />

    <b-form-group :label="$t('servers.ttl')" :state="validateState('ttl')">
      <multiselect
        v-model="form.ttl"
        :options="ttlList"
        track-by="id"
        label="name"
        :allowEmpty="false"
        :show-labels="false"
        :searchable="true"
        :placeholder="$t('servers.ttl')"
        :show-no-results="false"
      />
    </b-form-group>
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'AddRecord',
  mixins: [validationMixin],
  props: {
    confirmModal: Boolean,
    selected: String,
    dns_service_id: String,
    detailData: Object | Array,
  },
  data() {
    return {
      form: {
        name: '',
        type: '',
        content: '',
        priority: '',
        service: '',
        protocol: '',
        weight: '',
        port: '',
        target: '',
        ttl: { id: '0', name: this.$t('global.auto') },
        subdomain: false,
      },
      refreshName: true,
      refreshSRVFields: true,
      typeList: [
        { id: 'CNAME', name: 'CNAME' },
        { id: 'A', name: 'A' },
        { id: 'MX', name: 'MX' },
        { id: 'NS', name: 'NS' },
        { id: 'TXT', name: 'TXT' },
        { id: 'SRV', name: 'SRV' },
      ],
      ttlList: [
        { id: '0', name: this.$t('global.auto') },
        { id: '1800', name: this.$t('global.minutes', ['30']) },
        { id: '3600', name: this.$t('global.minutes', ['60']) },
        { id: '7200', name: this.$t('global.hours', ['2']) },
        { id: '14400', name: this.$t('global.hours', ['4']) },
        { id: '86400', name: this.$t('global.hours', ['24']) },
        { id: '2592000', name: this.$t('global.days', ['30']) },
      ],
    }
  },
  validations: {
    form: {
      type: {
        required,
      },
      ttl: {
        required,
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    async switchChange() {
      this.refreshName = false
      await this.$nextTick() // nextTick hack, v-if hack re-render dom
      this.refreshName = true
      this.form.name = ''
    },
    confirm() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        this.$emit('resetDetailForm', false)
        return
      }

      let params = {}

      if (this.form.subdomain) params.name = this.form.name
      else if (this.form.type && this.form.type.name != 'SRV') params.name = '@'
      if (this.form.type && this.form.type.id) params.type = this.form.type.id
      if (this.form.content) params.content = this.form.content
      if (this.form.ttl && this.form.ttl.id) params.ttl = this.form.ttl.id
      if (this.form.priority) params.priority = this.form.priority
      if (this.form.service) params.service = this.form.service
      if (this.form.protocol) params.protocol = this.form.protocol
      if (this.form.weight) params.weight = this.form.weight
      if (this.form.port) params.port = this.form.port
      if (this.form.target) params.target = this.form.target

      ApiService.post(
        `packetbender/dns/services/${this.dns_service_id}/domains/${this.$route.params.id}/records`,
        params
      )
        .then(({ data }) => {
          this.$emit('resetDetailForm', true)
          this.resetForm()
        })
        .catch((err) => {
          this.$emit('resetDetailForm', false)
        })
    },
    async selectedRecordType() {
      this.refreshSRVFields = false
      await this.$nextTick() // nextTick hack, v-if hack re-render dom
      this.refreshSRVFields = true
      this.form.priority = ''
      this.form.service = ''
      this.form.protocol = ''
      this.form.weight = ''
      this.form.port = ''
      this.form.target = ''
    },
    resetForm() {
      this.form.name = ''
      this.form.type = ''
      this.form.content = ''
      this.form.priority = ''
      this.form.service = ''
      this.form.protocol = ''
      this.form.weight = ''
      this.form.port = ''
      this.form.target = ''
      this.form.subdomain = false
      this.$v.$reset()
    },
  },
  watch: {
    confirmModal(newVal) {
      if (newVal) {
        this.confirm()
      }
    },
  },
}
</script>
